import type { SubjectValuesPayload } from '@Application/Subjects/Actions/subjectFetched';

class UpdateSubject {
	constructor(
		public readonly facilityId: number,
		public readonly subjectId: number,
		public readonly title: string,
		public readonly values: SubjectValuesPayload,
	) {
		Object.freeze(this);
	}

	toJSON(): Record<string, unknown> {
		return { title: this.title, values: this.values };
	}
}

export default UpdateSubject;
